import { createInjectorsEnhancer, forceReducerReload } from 'redux-injectors';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
const IS_PRODUCTION = import.meta.env.NODE_ENV !== "development";

import { configureStore, Tuple } from '@reduxjs/toolkit';

import { createReducer } from './reducers';
import { StoreEnhancer } from 'redux';

export function configureAppStore() {
  const reduxSagaMonitorOptions = {};
  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
  const { run: runSaga } = sagaMiddleware;

  // Create the store with saga middleware
  let middlewares = [sagaMiddleware];

  // LOG ONLY IN DEVELOPMENT/STAGING PRODUCTION OPTIMIZATIONS
  if (IS_PRODUCTION) {
    middlewares = [...middlewares];
  }
  const enhancers = [
    createInjectorsEnhancer({
      createReducer,
      runSaga,
    }),
  ];

  const store = configureStore({
    reducer: createReducer(),
    middleware: () => new Tuple(
        createLogger({
          collapsed: true,
          duration: true,
          timestamp: true,
        }),
        ...middlewares,
      ),
    devTools:
      /* istanbul ignore next line */
      IS_PRODUCTION || import.meta.env.PUBLIC_URL.length > 0,
    enhancers: (getDefaultEnhancers) => 
      getDefaultEnhancers().concat(...enhancers as StoreEnhancer[]),
  });

  // Make reducers hot reloadable, see http://mxs.is/googmo
  /* istanbul ignore next */
  if (import.meta.hot) {
    import.meta.hot.accept('./reducers', () => {
      forceReducerReload(store);
    });
  }

  return store;
}
